import './styles.scss'

import React from 'react'
import { useSelector } from 'react-redux'
import PropTypes from 'prop-types'

import railsContext from 'lib/selectors/rails-context'
import I18n from 'lib/i18n'

const GoodFit = ({ labelClassName, wrapperSpace, noborder, contentStyle = {}, className, mode }) => {
  const { i18nLocale: locale } = useSelector(railsContext)

  return (
    <div className={`widget white ${className} ${wrapperSpace ? 'space' : 'nospace'} ${noborder ? 'noborder' : ''}`}>
      {mode === 'widget' ? (
        <div className='good-fit-widget'>
          <h3 className={`boxtitle line  ${labelClassName || ''}`}>{I18n.t('bookings.good_fit.title')}</h3>
          <div className='padding-no-top2' style={{ ...contentStyle }}>
            <div className='good-fit-image-container'>
              <div className={`good-fit-image good-fit-image-${locale === 'fr' ? 'fr' : 'en'}`} />
            </div>
            <br />
            {I18n.t('bookings.good_fit.line_1')}
          </div>
        </div>
      ) : (
        <div className='good-fit'>
          <div className='good-fit-img'>
            <div className={`good-fit-image good-fit-image-${locale === 'fr' ? 'fr' : 'en'}`} />
          </div>
          <h4>{I18n.t('bookings.show.guarantee_title')}</h4>
          <ul>
            <li>{I18n.t('bookings.good_fit.line_1')}</li>
            <li>{I18n.t('bookings.show.guarantee_line_2')}</li>
          </ul>
        </div>
      )}
    </div>
  )
}

GoodFit.propTypes = {
  labelClassName: PropTypes.string,
  wrapperSpace: PropTypes.bool,
  noborder: PropTypes.bool,
  contentStyle: PropTypes.object,
  className: PropTypes.string,
  mode: PropTypes.string
}

export default GoodFit
